// The Meta Pixel is initialized once in public/index.html (which also sends the first PageView).
// This module sends Pixel events and mirrors them to first-party analytics (src/metrics/track.js).
// If the pixel is blocked (ad blockers) calls are silently skipped.
import { track } from "../metrics/track";

const fbq = (...args) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq(...args);
  }
};

let lastPath = null;

export function trackPageView(path) {
  if (path === lastPath) return;
  const first = lastPath === null;
  lastPath = path;
  track("page_view");
  if (!first) fbq("track", "PageView"); // the first PageView was already sent by index.html
}

const CONTACT_TYPES = {
  Poziv: "call",
  Viber: "viber",
  WhatsApp: "whatsapp",
  Email: "email",
  Social: "social",
  Mapa: "map_open",
};

// Only real contact methods count as a Pixel "Contact" conversion; social/map clicks would
// inflate ad conversions, so they go to first-party analytics only.
const PIXEL_CONTACT = new Set(["Poziv", "Viber", "WhatsApp", "Email"]);

// Click on a phone / Viber / WhatsApp / email / social link.
export const trackContact = (method, extra = {}) => {
  if (PIXEL_CONTACT.has(method)) fbq("track", "Contact", { method, ...extra });
  track(CONTACT_TYPES[method] || "cta", { source: extra.source, label: extra.label });
};

export const trackEmail = (source) => trackContact("Email", { source });

// Successful inquiry (form). The old site reported forms as "Contact", so we keep
// sending it too, so existing campaigns don't lose their optimization signal.
export const trackLead = (source, extra = {}) => {
  fbq("track", "Lead", { content_name: source, ...extra });
  fbq("track", "Contact", { method: "Contact Form", source });
  track("lead", { source, label: extra.unit || extra.interesovanje });
};

export const trackViewContent = (name, extra = {}) => {
  fbq("track", "ViewContent", { content_name: name, ...extra });
  track("view_content", { label: name });
};
